export default "__VITE_ASSET__Ype1SbKQ__"